import { useState, useEffect } from 'react'
import { MIN_FULLWIDTH } from '../data/variables';

export const useWindowSize = () => {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight })

  useEffect(() => {
    const handler = () => setSize({ width: window.innerWidth, height: window.innerHeight })
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return {
    size,
    isFullSize: size.width > MIN_FULLWIDTH,
  }
}
